import { Flag, User, Users } from "lucide-react";
import { styles } from "../styles";
import { OptionCard } from "../common/OptionCard";
import { Clubhouse_LeagueType } from "../../enums";
import type { LeagueFormValues } from "../leagueFormSchema";
import { useFormContext, Controller } from "react-hook-form";

export function LeagueFormatStep() {
  const {
    control,
    formState: { errors },
  } = useFormContext<LeagueFormValues>();

  return (
    <div className="flex flex-col items-center gap-3">
      <Controller
        name="wizard.leagueType"
        control={control}
        render={({ field }) => (
          <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-3">
            <OptionCard
              icon={<User className="size-8" />}
              title="Individual"
              description="Players compete on their own."
              selected={field.value === Clubhouse_LeagueType.INDIVIDUAL}
              onClick={() => field.onChange(Clubhouse_LeagueType.INDIVIDUAL)}
            />
            <OptionCard
              icon={<Users className="size-8" />}
              title="Team"
              description="Players compete together as teams."
              selected={field.value === Clubhouse_LeagueType.TEAM}
              onClick={() => field.onChange(Clubhouse_LeagueType.TEAM)}
            />
            <OptionCard
              icon={<Flag className="size-8" />}
              title="Scramble"
              description="Teams combine shots into one score."
              selected={field.value === Clubhouse_LeagueType.SCRAMBLE}
              onClick={() => field.onChange(Clubhouse_LeagueType.SCRAMBLE)}
            />
          </div>
        )}
      />
      {errors.wizard?.leagueType && (
        <p className={styles.wizardErrorCls}>
          {errors.wizard.leagueType.message}
        </p>
      )}
    </div>
  );
}
